export const ListQueryKey = 'projectRaffleRecords';
export const DetailQueryKey = 'projectRaffleRecord';

export const Urls = {
  selectUrl: '/raffle/list',
  updateUrl: '/raffle/update',
  deleteUrl: '/raffle/delete',
  createUrl: '/raffle/create',
  detailUrl: '/raffle/info',
};
